var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgESignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_4315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3327 19.0293C15.4803 20.5891 14.0048 21.1582 14.0048 21.1582C14.0048 21.1582 7.13311 21.0739 4.49822 21.2847C1.86333 21.4954 1.7793 19.5351 1.7793 19.5351C1.7793 19.5351 1.94751 7.11958 1.9266 5.054C1.90569 2.98842 3.33883 2.77734 3.33883 2.77734H10.1263L14.7425 7.52008C14.7425 7.52008 15.6276 8.53181 15.3431 9.73351",
    stroke: "#E5E7EB",
    strokeWidth: 1.55798,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10065 3.08789V7.93601C9.10065 7.93601 9.05849 9.29915 11.1102 8.9197L15.3679 8.87286",
    stroke: "#E5E7EB",
    strokeWidth: 1.55798,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7749 17.5488C3.7749 17.5488 5.09587 17.9282 5.70011 16.7478C6.30435 15.5674 6.14981 13.2206 7.30211 15.188L7.82916 17.186C7.85866 17.2977 8.00506 17.3244 8.07196 17.2301C8.46899 16.6707 9.48645 15.4533 10.0986 16.6773C10.8714 18.2231 13.2323 17.5205 13.2323 17.5205",
    stroke: "#E5E7EB",
    strokeWidth: 1.55798,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4211 9.69677L19.7877 8.25986C19.7877 8.25986 20.5184 7.42026 21.3721 8.22126C21.8332 8.65383 22.1416 9.08745 22.3277 9.39482C22.3996 9.51364 22.4318 9.6523 22.4197 9.79068C22.4075 9.92906 22.3516 10.06 22.26 10.1644L20.5078 12.163L16.6102 16.1313C16.4984 16.2451 16.3589 16.3278 16.2055 16.3713L13.4259 17.1592C13.2945 17.1964 13.1719 17.0775 13.2052 16.945L13.8547 14.3652C13.8841 14.2483 13.945 14.1416 14.0306 14.0567L18.4211 9.69677Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.15592,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1627 9.39153L18.2104 10.3438L19.9003 12.0336L20.8525 11.0814L19.1627 9.39153Z",
    fill: "#E5E7EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_4315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20.081,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgESignature);
export default __webpack_public_path__ + "static/media/E-signature.bb897fe0742f2adccee84f133ec8717a.svg";
export { ForwardRef as ReactComponent };